/* RESPONSIBLE TEAM: team-reporting */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  unsubscribe(model) {
    let url = `${this.buildURL('reporting/report-subscription', model.id)}/unsubscribe`;
    return this.ajax(url, 'POST');
  },
});
